import React from 'react';

const ContactSection = ({ data }) => {
  return (
    <section className="p-80px-tb contact-section bg-light">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center m-50px-b">
            <h2 className="section-title font-weight-bold m-20px-b">{data.title}</h2>
            <p className="lead text-muted">{data.subtitle}</p>
          </div>
        </div>

        <div className="row">
          {/* 連絡先情報 */}
          <div className="col-lg-4 m-30px-b">
            <div className="contact-info">
              {/* 住所 */}
              <div className="info-item bg-white p-30px rounded shadow-sm m-20px-b">
                <div className="d-flex align-items-start">
                  <i className={`${data.contactInfo.address.icon} icofont-3x text-primary m-20px-r`}></i>
                  <div>
                    <h5 className="font-weight-bold m-15px-b">{data.contactInfo.address.title}</h5>
                    <p className="text-muted m-0" dangerouslySetInnerHTML={{ __html: data.contactInfo.address.info }}></p>
                  </div>
                </div>
              </div>

              {/* 電話番号 */}
              <div className="info-item bg-white p-30px rounded shadow-sm m-20px-b">
                <div className="d-flex align-items-start">
                  <i className={`${data.contactInfo.phone.icon} icofont-3x text-primary m-20px-r`}></i>
                  <div>
                    <h5 className="font-weight-bold m-15px-b">{data.contactInfo.phone.title}</h5>
                    <p className="text-muted m-0" dangerouslySetInnerHTML={{ __html: data.contactInfo.phone.info }}></p>
                  </div>
                </div>
              </div>

              {/* メールアドレス */}
              <div className="info-item bg-white p-30px rounded shadow-sm">
                <div className="d-flex align-items-start">
                  <i className={`${data.contactInfo.email.icon} icofont-3x text-primary m-20px-r`}></i>
                  <div>
                    <h5 className="font-weight-bold m-15px-b">{data.contactInfo.email.title}</h5>
                    <p className="text-muted m-0" dangerouslySetInnerHTML={{ __html: data.contactInfo.email.info }}></p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* お問い合わせフォーム */}
          <div className="col-lg-8">
            <div className="contact-form bg-white p-50px rounded shadow-sm">
              <h3 className="font-weight-bold m-30px-b">{data.formTitle}</h3>
              <p className="text-muted m-30px-b">{data.formDescription}</p>

              <form name="contact" method="POST" data-netlify="true" data-netlify-honeypot="bot-field">
                {/* Netlify Forms用の隠しフィールド */}
                <input type="hidden" name="form-name" value="contact" />
                <div style={{ display: 'none' }}>
                  <label>
                    Don't fill this out: <input name="bot-field" />
                  </label>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group" style={{ marginBottom: '30px' }}>
                      <label htmlFor="company" style={{ marginBottom: '10px', fontWeight: '600' }}>会社名・法人名 <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        id="company"
                        name="company"
                        placeholder="例：株式会社○○"
                        style={{ padding: '12px 15px', height: '48px', fontSize: '16px' }}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group" style={{ marginBottom: '30px' }}>
                      <label htmlFor="department" style={{ marginBottom: '10px', fontWeight: '600' }}>部署名</label>
                      <input
                        type="text"
                        className="form-control"
                        id="department"
                        name="department"
                        placeholder="例：情報システム部"
                        style={{ padding: '12px 15px', height: '48px', fontSize: '16px' }}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group" style={{ marginBottom: '30px' }}>
                      <label htmlFor="name" style={{ marginBottom: '10px', fontWeight: '600' }}>ご担当者名 <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        placeholder="例：山田 太郎"
                        style={{ padding: '12px 15px', height: '48px', fontSize: '16px' }}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group" style={{ marginBottom: '30px' }}>
                      <label htmlFor="position" style={{ marginBottom: '10px', fontWeight: '600' }}>役職</label>
                      <input
                        type="text"
                        className="form-control"
                        id="position"
                        name="position"
                        placeholder="例：部長、課長、担当"
                        style={{ padding: '12px 15px', height: '48px', fontSize: '16px' }}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group" style={{ marginBottom: '30px' }}>
                      <label htmlFor="email" style={{ marginBottom: '10px', fontWeight: '600' }}>メールアドレス <span className="text-danger">*</span></label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder="例：yamada@example.co.jp"
                        style={{ padding: '12px 15px', height: '48px', fontSize: '16px' }}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group" style={{ marginBottom: '30px' }}>
                      <label htmlFor="phone" style={{ marginBottom: '10px', fontWeight: '600' }}>電話番号 <span className="text-danger">*</span></label>
                      <input
                        type="tel"
                        className="form-control"
                        id="phone"
                        name="phone"
                        placeholder="例：03-1234-5678"
                        style={{ padding: '12px 15px', height: '48px', fontSize: '16px' }}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group" style={{ marginBottom: '30px' }}>
                      <label htmlFor="inquiry_type" style={{ marginBottom: '10px', fontWeight: '600' }}>お問い合わせ種別 <span className="text-danger">*</span></label>
                      <select
                        className="form-control"
                        id="inquiry_type"
                        name="inquiry_type"
                        style={{ padding: '12px 15px', height: '48px', fontSize: '16px' }}
                        required
                      >
                        <option value="">選択してください</option>
                        <option value="consultation">導入相談・見積もり依頼</option>
                        <option value="poc">PoC（概念実証）のご相談</option>
                        <option value="development">受託開発・カスタマイズ</option>
                        <option value="support">技術支援・コンサルティング</option>
                        <option value="partnership">パートナーシップ・協業</option>
                        <option value="seminar">セミナー・研修のご依頼</option>
                        <option value="demo">デモ・トライアルのお申し込み</option>
                        <option value="other">その他</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group" style={{ marginBottom: '30px' }}>
                      <label htmlFor="budget" style={{ marginBottom: '10px', fontWeight: '600' }}>ご予算</label>
                      <select
                        className="form-control"
                        id="budget"
                        name="budget"
                        style={{ padding: '12px 15px', height: '48px', fontSize: '16px' }}
                      >
                        <option value="">選択してください</option>
                        <option value="under_1m">100万円未満</option>
                        <option value="1m_5m">100万円〜500万円</option>
                        <option value="5m_10m">500万円〜1,000万円</option>
                        <option value="10m_50m">1,000万円〜5,000万円</option>
                        <option value="over_50m">5,000万円以上</option>
                        <option value="undecided">未定・相談したい</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group" style={{ marginBottom: '30px' }}>
                      <label htmlFor="timeline" style={{ marginBottom: '10px', fontWeight: '600' }}>導入予定時期</label>
                      <select
                        className="form-control"
                        id="timeline"
                        name="timeline"
                        style={{ padding: '12px 15px', height: '48px', fontSize: '16px' }}
                      >
                        <option value="">選択してください</option>
                        <option value="immediate">すぐに導入したい</option>
                        <option value="1_3months">1〜3ヶ月以内</option>
                        <option value="3_6months">3〜6ヶ月以内</option>
                        <option value="6_12months">6ヶ月〜1年以内</option>
                        <option value="over_1year">1年以上先</option>
                        <option value="undecided">未定・情報収集段階</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group" style={{ marginBottom: '30px' }}>
                      <label htmlFor="how_found" style={{ marginBottom: '10px', fontWeight: '600' }}>弊社をお知りになったきっかけ</label>
                      <select
                        className="form-control"
                        id="how_found"
                        name="how_found"
                        style={{ padding: '12px 15px', height: '48px', fontSize: '16px' }}
                      >
                        <option value="">選択してください</option>
                        <option value="search">検索エンジン</option>
                        <option value="referral">紹介・口コミ</option>
                        <option value="seminar">セミナー・イベント</option>
                        <option value="sns">SNS</option>
                        <option value="media">メディア・記事</option>
                        <option value="other">その他</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="form-group" style={{ marginBottom: '30px' }}>
                  <label htmlFor="message" style={{ marginBottom: '10px', fontWeight: '600' }}>お問い合わせ内容 <span className="text-danger">*</span></label>
                  <textarea
                    className="form-control"
                    id="message"
                    name="message"
                    rows="8"
                    placeholder="具体的なご要望、現在の課題、導入を検討されているシステムの規模など、できるだけ詳しくご記入ください。"
                    style={{ padding: '15px', fontSize: '16px', lineHeight: '1.6' }}
                    required
                  ></textarea>
                </div>

                <div className="form-group" style={{ marginBottom: '35px' }}>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="privacy_policy"
                      name="privacy_policy"
                      style={{ marginTop: '6px', width: '18px', height: '18px' }}
                      required
                    />
                    <label className="form-check-label" htmlFor="privacy_policy" style={{ marginLeft: '8px', fontSize: '15px' }}>
                      <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>に同意する <span className="text-danger">*</span>
                    </label>
                  </div>
                </div>

                <button type="submit" className="btn btn-default btn-filled animated-btn">
                  送信する <i className="icofont-arrow-right"></i>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;